







import { Component, Vue, Prop } from 'vue-property-decorator'; // デコレータ
import router from '../router';
import axios from 'axios';
import { ScreenName } from '../CommonUtils/fixed/ScreenName';
import { Constants } from '../CommonUtils/fixed/Constants';
import { supervisingModule } from '../store/modules/OperationSupervising';
import { kanriManagementModule } from './store/modules/KanriManagement';
import { KnariScreenName } from './fixed/KanriScreenName';

@Component
export default class Kanri extends Vue {
}
